module.exports = __webpack_public_path__ + "img/Support-skill-204.c3aba4df.png";